module.exports = __webpack_public_path__ + "static/media/Disclaimer_RCP.f517ad40.pdf";